/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Color_DescInputs */



/**
* | output |
* | --- |
* | "The colour this conversation type wears everywhere." |
*
* @param {Settings_Template_Color_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_color_desc = /** @type {((inputs?: Settings_Template_Color_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Color_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De kleur waarmee dit gesprekstype overal wordt getoond.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La couleur de ce type de conversation partout dans Wundo.")
	return /** @type {LocalizedString} */ ("The colour this conversation type wears everywhere.")
});